import { takeLatest, put, call } from 'redux-saga/effects';
import { httpService } from '@commons';

import {
  PRORROGAR_TESTE_CONTA_AGRARE,
  PRORROGAR_TESTE_CONTA_AGRARE_PENDING,
  PRORROGAR_TESTE_CONTA_AGRARE_SUCCESS,
  PRORROGAR_TESTE_CONTA_AGRARE_FAILURE,
  NEW_FILTER_CONTA_AGRARE
} from '../actionTypes';

const prorrogarTesteConta = async (id, newdData) => {
  return httpService.putApiManager(`/clienteAgrare/prorrogarTeste/${id}?novaDataFim=${newdData}`, null);
}

function* sagaProrrogarTesteContaAgrare(action) {
  yield put({ type: PRORROGAR_TESTE_CONTA_AGRARE_PENDING });

  try {
    const registro = yield call(prorrogarTesteConta, action.data.id, action.data.dataFimPeriodoTeste);
    yield put({ type: PRORROGAR_TESTE_CONTA_AGRARE_SUCCESS, registro });

    yield put({ type: NEW_FILTER_CONTA_AGRARE, newFilter: false });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: PRORROGAR_TESTE_CONTA_AGRARE_FAILURE });

    if (action.resolve) {
      action.resolve();
    }
  }
}

export default function* watchProrrogarTesteContaAgrare() {
  yield takeLatest(PRORROGAR_TESTE_CONTA_AGRARE, sagaProrrogarTesteContaAgrare);
}
